import { ReviewSummaryResponse } from '|/services/purchase-api';

export interface ManufacturerWarrantyRow {
  key: 'basic' | 'powertrain';
  label: string;
  terms: string;
}

type Vehicle = NonNullable<ReviewSummaryResponse['vehicle']>;

const formatMiles = (miles: number) =>
  miles % 1000 === 0 ? `${miles / 1000}k mi.` : `${miles.toLocaleString('en-US')} mi.`;

const formatTerms = (months?: number, miles?: number) =>
  [months ? `${months} mo.` : null, miles ? formatMiles(miles) : null].filter(Boolean).join(' / ');

const toRow = (
  key: ManufacturerWarrantyRow['key'],
  label: string,
  months?: number,
  miles?: number
): ManufacturerWarrantyRow | null => {
  const terms = formatTerms(months, miles);
  return terms ? { key, label, terms } : null;
};

/**
 * The four `manufacturer*Warranty*` fields are absent from the summary/review payload
 * whenever the vehicle has no remaining factory warranty — an empty result means
 * "hide the Factory Warranty block entirely", not "render it with no terms".
 */
export const deriveManufacturerWarranty = (vehicle?: Vehicle | null): ManufacturerWarrantyRow[] => {
  if (!vehicle) return [];

  return [
    toRow(
      'basic',
      'Basic Limited',
      vehicle.manufacturerBasicWarrantyMonths,
      vehicle.manufacturerBasicWarrantyMiles
    ),
    toRow(
      'powertrain',
      'Powertrain Limited',
      vehicle.manufacturerDriveTrainWarrantyMonths,
      vehicle.manufacturerDriveTrainWarrantyMiles
    )
  ].filter((row): row is ManufacturerWarrantyRow => row !== null);
};

export default deriveManufacturerWarranty;
